import script from "./DesignDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignDetail.vue?vue&type=script&setup=true&lang=js"

import "./DesignDetail.vue?vue&type=style&index=0&id=142057bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142057bc"]])

export default __exports__